import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useSearchInput } from 'hooks/useSearchInput';

export const query = gql`
  query GetAnnualTypesAdmin($input: GetAnnualTypesInput!) {
    getAnnualTypesAdmin(input: $input) {
      count
      results {
        id
        name
        type
        account {
          id
          business_dba
        }
      }
    }
  }
`;

export function useGetAnnualCategories(accountFilter) {
  const { input: search } = useSearchInput();

  // Only pass valid API fields (exclude account_id which is for routing)
  // eslint-disable-next-line no-unused-vars
  const { account_id, ...validSearch } = search;

  return useQuery(query, {
    variables: {
      input: {
        ...validSearch,
        ...(accountFilter ? { accountFilter } : null),
      },
    },
  });
}
